import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { removeCompanyFragmentFromUrl, RoutingService } from "@skylab-angular-shared/core";
import { ToastService } from "@skylab-angular-shared/ui";
import { AppStates } from "@skylab-shared/scenes";

export const pathNotFoundCanActivate = (): CanActivateFn => {
	return (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
		const routing = inject(RoutingService);
		const toastService = inject(ToastService);

        const url = removeCompanyFragmentFromUrl(state.url.split('?')?.[0]?.replace(/^\//, ''));
		if (url === "") {
			routing.navigate([AppStates.dashboard.url]);
			return false;
		};

		const oldRoute = routing.appStates.find(elem => elem.oldUrls?.includes(url));

		if (!oldRoute) {
			toastService.showAsync({
				type: 'error',
				text: `Adres ${url} nie istnieje.`,
			});
			routing.navigate([AppStates.dashboard.url]);
		} else {
			routing.navigate([oldRoute.url], {queryParams: state.root.queryParams});
		}

		return false;
	};
};
